import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { requestDentistListExportTemplate } from 'apollo/templates/user';
import { AsyncExportEventData, useAsyncExport } from './useAsyncExport';

export const DENTIST_LIST_EXPORT_EVENTS = {
    ready: 'DENTIST_LIST_EXPORT_READY',
    error: 'DENTIST_LIST_EXPORT_ERROR',
} as const;

type UseDentistListExportOptions = {
    /** Customer scope; omit for the lab-wide export. */
    clinicId?: string;
};

/** Excel export of a customer's dentists (with `clinicId`) or of every dentist of the lab. */
export const useDentistListExport = ({ clinicId }: UseDentistListExportOptions = {}) => {
    const { t: translate } = useTranslation(['users']);
    const variables = useMemo(() => ({ clinicId }), [clinicId]);
    const isForThisScope = useCallback(
        (data: AsyncExportEventData) => (data.clinicId ?? undefined) === clinicId,
        [clinicId],
    );
    return useAsyncExport({
        mutation: requestDentistListExportTemplate,
        variables,
        events: DENTIST_LIST_EXPORT_EVENTS,
        isForThisScope,
        emptyMessage: translate('users:EXPORT_NO_DENTISTS'),
    });
};
